import { ColDef } from "@ag-grid-community/core";
import clsx from "clsx";
import { FundFamilyUseAllocationTableTotalHeaderRenderer } from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableTotalRenderers";
import {
  fundFamilyUseAllocationTableTotalHeaderColSpan,
  isFundFamilyUseAllocationTableTotalHeader,
} from "shared/components/fund-family-use-allocation/FundFamilyUseAllocationTableUtils";
import { maybernTableSuppressKeyboardEventForInput } from "shared/components/table/maybern/MaybernTableSuppressKeyboardEventForInput";

export const fundFamilyUseAllocationTableDefaultColDef: ColDef = {
  suppressMovable: true,
  resizable: true,
  suppressKeyboardEvent: maybernTableSuppressKeyboardEventForInput,
  suppressHeaderMenuButton: true,
  sortable: false,
  cellClass: (params) =>
    clsx({
      "mb-cell-is-total-label":
        isFundFamilyUseAllocationTableTotalHeader(params),
    }),
  colSpan: (params) =>
    isFundFamilyUseAllocationTableTotalHeader(params)
      ? fundFamilyUseAllocationTableTotalHeaderColSpan(params)
      : 1,
  cellRendererSelector: (params) => {
    if (isFundFamilyUseAllocationTableTotalHeader(params)) {
      return {
        component: FundFamilyUseAllocationTableTotalHeaderRenderer,
      };
    }
  },
};
